/**
 * Object.hasOwn is missing on iOS < 15.4.
 * @telegram-apps/sdk 3.4+ (valibot) uses it when parsing launch params →
 * LaunchParamsRetrieveError on older Telegram iOS WebViews.
 */
if (!Object.hasOwn) {
  Object.hasOwn = function objectHasOwn(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }
}
